class CartCountController {
    constructor($scope, $rootScope, cartService) {
        'ngInject';

        this.$scope = $scope;
        this.service = cartService;
        this.count = 0;
    }

    get intCount() {
        return parseInt(this.count);
    }
}

let cartCountComponent = {
    bindings: {
        count: '@'
    },
    template: `
        <span ng-if="$ctrl.service.loaded">{{ $ctrl.service.items.length }}</span>
        <span ng-if="!$ctrl.service.loaded">{{ $ctrl.count }}</span>`,
    controller: CartCountController
}

export default cartCountComponent;